import * as React from 'react';

import { CloudImage } from '@components/CloudImage';
import { Text } from '@components/typography';
import {
  MainWrapper,
  ContentWrapper,
  QuoteWrapper,
  LogoWrapper,
  CustomCloudImage,
  ImageWapper,
  ColumnWrapper,
  ColumnsWrapper,
} from './HomeNewsSection.styles';

import { useTranslation } from 'react-i18next';

const firstLogo = [
  'home/pr-logos/vogue_logo.svg',
  'home/pr-logos/new-york-times_logo.svg',
  'home/pr-logos/refinery29_logo.svg',
  'home/pr-logos/huffpost_logo.svg',
];
const lastLogo = [
  'home/pr-logos/techcrunch_logo.svg',
  'home/pr-logos/bustle_logo.svg',
  'home/pr-logos/mashable_logo.svg',
  'home/pr-logos/brides_logo.svg',
];

export const HomeNewsSection = () => {
  const { t } = useTranslation('home');
  const homeNewsRoomData = t('newsroom');
  return (
    <MainWrapper as="section" backgroundColor="white" id="Press">
      <ColumnsWrapper>
        <ColumnWrapper>
          <ContentWrapper paddingY={[7, 11, 12]} paddingX={[5, 5, 11]}>
            <QuoteWrapper>
              <Text tagName="h2" variant="hed56" color="mono1">
                {homeNewsRoomData.quote}
              </Text>
              <ImageWapper>
                <CloudImage src={homeNewsRoomData.quoteImageSrc} alt="" optimization="default" />
              </ImageWapper>
            </QuoteWrapper>
            <LogoWrapper justifyContent="space-between" alignItems="center">
              {firstLogo.map((data, i) => (
                <div key={i}>
                  <CustomCloudImage src={data} alt="" padding="15px 24px" optimization="default" />
                </div>
              ))}
            </LogoWrapper>
            <LogoWrapper justifyContent="space-between" alignItems="center">
              {lastLogo.map((data, k) => (
                <div key={k}>
                  <CustomCloudImage src={data} alt="" padding="15px 24px" optimization="default" />
                </div>
              ))}
            </LogoWrapper>
          </ContentWrapper>
        </ColumnWrapper>
      </ColumnsWrapper>
    </MainWrapper>
  );
};
